import html2canvas from 'html2canvas';
import { useEffect, useState, useRef } from 'react';
import {
    CertificateModelResponse,
    CertificateResponse,
    ClassResponse
} from "../services/api.response.service";
import { Button, Modal } from "react-bootstrap";

interface CertificateModalProps {
    show: boolean;
    onHide: () => void;
    url?: string;
    classDetails?: ClassResponse;
    certificateOwner?: CertificateModelResponse;
}

const CertificateModal = ({
    show = false,
    onHide,
    url,
    classDetails,
    certificateOwner
}: CertificateModalProps) => {

    const [isDownloading, setIsDownloading] = useState(false);
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const iframeRef = useRef<HTMLIFrameElement>(null);

    // const certificateUrl = url || `https://api.ecampus-app.com/api/v4/certificates/0b07b779-925b-4cf8-afac-8385de44d6ec`;
    const certificateUrl = url || ``;
    // Load iframe only once when modal is first shown
    useEffect(() => {
        if (show && !iframeLoaded) {
            setIframeLoaded(true);
        }
    }, [show, iframeLoaded]);

    const handleDownload1 = async () => {
        if (isDownloading) return;
        
        setIsDownloading(true);
        try {
            // Create a hidden iframe with exact dimensions
            // const downloadIframe = document.createElement('iframe');
            // downloadIframe.src = certificateUrl;
            // downloadIframe.style.position = 'fixed';
            // downloadIframe.style.top = '-10000px';
            // downloadIframe.style.left = '-10000px';
            // downloadIframe.style.width = '1024px';
            // downloadIframe.style.height = '768px';
            // downloadIframe.style.visibility = 'hidden';
            // document.body.appendChild(downloadIframe);
            //
            // // Wait for iframe to load
            // await new Promise<void>((resolve, reject) => {
            //     const timeout = setTimeout(() => {
            //         reject(new Error('Timeout loading certificate'));
            //     }, 10000); // 10 second timeout
            //
            //     downloadIframe.onload = () => {
            //         clearTimeout(timeout);
            //         resolve();
            //     };
            //
            //     downloadIframe.onerror = () => {
            //         clearTimeout(timeout);
            //         reject(new Error('Failed to load certificate'));
            //     };
            // });
            //
            // // Wait a bit more for content to render
            // await new Promise(resolve => setTimeout(resolve, 1500));
            //
            // // Check if contentDocument is available
            // if (!downloadIframe.contentDocument || !downloadIframe.contentDocument.body) {
            //     throw new Error('Cannot access iframe content. This may be due to CORS restrictions.');
            // }

            const target = document.getElementById('certificate-container');
            if (!target) {
                alert('Target div not found');
                return;
            }

            // Use html2canvas to capture the iframe content
            // const canvas = await html2canvas(downloadIframe.contentDocument.body, {
            const canvas = await html2canvas(target, {
                width: 1024,
                height: 768,
                scale: 1,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                logging: false,
            });

            // Convert to blob and download
            canvas.toBlob((blob) => {
                if (!blob) {
                    console.error('Failed to create blob');
                    // document.body.removeChild(target);
                    setIsDownloading(false);
                    return;
                }

                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const fileName = `certificate-${classDetails?.name?.replace(/[^a-z0-9]/gi, '_').toLowerCase() || 'completion'}`;
                link.download = `${fileName}-${new Date().getTime()}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                // document.body.removeChild(downloadIframe);
                setIsDownloading(false);
            }, 'image/png', 1.0);

        } catch (error) {
            console.error('Download failed:', error);
            setIsDownloading(false);
            
            // Fallback: open in new window for manual download/print
            const fallbackWindow = window.open(certificateUrl, '_blank');
            if (!fallbackWindow) {
                alert('Please allow pop-ups to download the certificate, or try using the Share button to copy the link.');
            }
        }
    };

    const handleDownload = async () => {
        if (isDownloading) return;
        setIsDownloading(true);

        // const target = document.getElementById('certificate-container1');

        // if (!target) return;
        console.log('Capture certificateOwner:', certificateOwner);
        try {

            const link = document.createElement('a');
            link.download = `certificate-${Date.now()}.png`;
            // link.href = certificateOwner?.pdf_url ? certificateOwner?.pdf_url : canvas.toDataURL('image/png');
            link.href = certificateOwner?.pdf_url ? certificateOwner?.pdf_url : '';
            link.click();
            console.log(
                certificateOwner?.pdf_url,
                // canvas.toDataURL('image/png')
            )
            setIsDownloading(false);
        } catch (err) {
            console.error('Capture failed:', err);
            alert('Image generation failed — check console');
        }
        setIsDownloading(false);
    };

    const handleShare = async () => {
        const shareData = {
            title: 'My Certificate',
            text: `I completed ${classDetails?.name}!`,
            url: certificateUrl
        };

        try {
            // Check if Web Share API is available
            if (navigator.share) {
                // Check if canShare exists and the data can be shared
                if (!navigator.canShare || navigator.canShare(shareData)) {
                    await navigator.share(shareData);
                    return;
                }
            }

            // Fallback: copy to clipboard
            await navigator.clipboard.writeText(certificateUrl);
            alert('Certificate link copied to clipboard!');
        } catch (error) {
            // If share was cancelled or failed, try clipboard as fallback
            try {
                await navigator.clipboard.writeText(certificateUrl);
                alert('Certificate link copied to clipboard!');
            } catch (clipboardError) {
                console.error('Share and clipboard failed:', error, clipboardError);
                alert('Unable to share certificate. Please copy the URL manually.');
            }
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            contentClassName="bg-transparent border-0"
        >
            {/* <Modal.Header closeButton>
            <Modal.Title>Certificate of Completion</Modal.Title>
            </Modal.Header> */}
            <Modal.Body className="p-0 bg-transparent">
                <div
                    style={{
                        position: 'relative',
                        // width: '100%',
                        // maxWidth: '1024px',
                        // width: '1024px',
                        // height: '768px',
                        margin: '0 auto',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px',
                        overflow: 'hidden'
                    }}
                >
                    <div
                        className='certificate-container'
                        id='certificate-container'
                    >

                        {iframeLoaded && (
                            <iframe
                                ref={iframeRef}
                                src={certificateUrl}
                                className={`certificate-inner ${show ? 'd-block' : 'd-none'}`}
                                title="Certificate"
                                id="certificate-iframe"
                                loading="eager"
                                style={{
                                    width: '1024px !important',
                                    height: '768px',
                                    border: 'none',
                                    margin: '0 auto',
                                }}
                            />
                        )}
                    </div>
                    {/* Action Buttons - Visible on all screens */}
                    <div className="d-flex gap-2 mt-3 px-3 mb-3">
                        <Button
                            variant="primary"
                            className="ec-btn flex-fill"
                            onClick={handleDownload}
                            disabled={isDownloading}
                        >
                            {isDownloading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Downloading...
                                </>
                            ) : (
                                <>
                                    <i className="las la-download me-2"></i>
                                    Download
                                </>
                            )}
                        </Button>

                        {/* <Button
                            variant="outline-primary"
                            className="flex-fill d-flex align-items-center justify-content-center"
                            onClick={handleShare}
                            disabled={isDownloading}
                        >
                            <i className="las la-share me-2"></i>
                            Share
                        </Button> */}
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default CertificateModal;